import { render, staticRenderFns } from "./Necropsy_EachID.vue?vue&type=template&id=3171f3a5&scoped=true"
import script from "./Necropsy_EachID.vue?vue&type=script&lang=js"
export * from "./Necropsy_EachID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3171f3a5",
  null
  
)

export default component.exports